import {getYoutubeVideoUrl} from '@cohort/shared/apps/youtube/common';
import type {YoutubeCommentTriggerStruct} from '@cohort/shared/apps/youtube/triggers/comment';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaWithRefresh from '@cohort/wallet/components/challenges/OpenCtaWithRefresh';
import {useTranslation} from 'react-i18next';

const YoutubeCommentTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<YoutubeCommentTriggerStruct>
> = ({config, trackingMetadata, stepId, processStepVerification}) => {
  const {t} = useTranslation('app-youtube', {
    keyPrefix: 'triggerIntegrations.comment',
  });

  return (
    <OpenCtaWithRefresh
      url={getYoutubeVideoUrl(config.videoId)}
      stepId={stepId}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
      ctaTitle={t('ctaTitle')}
      refreshCtaTitle={t('refreshTitle')}
    />
  );
};

export default YoutubeCommentTriggerActionCtaComponent;
